import fetch from 'isomorphic-fetch'
import { getCookie } from '../middleware/macmillan'
import { getAPIendpointPrefix } from '../actions/apiHelper'

export default (data, action) => {
  const { activity } = data
  const isAchieve = activity.config.isAchieve
  const isPreviewMode = activity.config.isInstructorView || activity.config.simulateData

  if (isAchieve && !isPreviewMode) {
    if (action === 'LOG_CORRECT_ATTEMPT' || action === 'LOG_INCORRECT_ATTEMPT') {
      const isCorrect = data.activity.score.curCard.completed
      questionAttempted(data, isCorrect)
    }

    if (action === 'RESUME_ACTIVITY' || action === 'NEXT_ITEM') {
      questionViewed(data)
    }
  }
}

function questionAttempted (data, isCorrect) {
  sendEvent(data, 'question_attempted', isCorrect)
}

function questionViewed (data, isCorrect) {
  sendEvent(data, 'question_viewed')
}

function sendEvent (data, event, isCorrect = null) {
  if (isCorrect !== null) {
    data.isCorrect = isCorrect
  }

  const idToken = getCookie('id_token')
  const resourceId = data.activity.config.itemId

  fetch(getAPIendpointPrefix() + 'api/v1/send_event.php', {
    method: 'POST',
    body: JSON.stringify({
      token: idToken,
      resourceId,
      event,
      data
    })
  }).then(res => res.text())
}
